import React, { Component, Fragment } from "react";
import { Button, Checkbox, Form, Divider, Popconfirm, Spin } from "antd";
import styles from "../index.module.less";
import "ag-grid/dist/styles/ag-grid.css";
import "ag-grid/dist/styles/ag-theme-balham.css";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import { observer, inject } from "mobx-react";
import { autorun } from "mobx";
import AddBlockedSitesDialog from "./AddBlockSitesDialog";

const FormItem = Form.Item;

@inject("rootStore")
@observer
class BlockedSitesForm extends Component {
	constructor(props) {
		super(props);
		this.deleteBlockedSitesDisposer = null;
		this.addBlockedSitesDisposer = null;
	}

	onGridReady = params => {
		const {
			rootStore: { optionsStore }
		} = this.props;

		this.gridApi = params.api;
		this.gridColumnApi = params.columnApi;

		const ui = optionsStore.ui;

		this.addBlockedSitesDisposer = autorun(() => {
            const blockedSites = ui.addedBlockedSites.filter(blockedSite => {
                const existingBlockedSite = this.gridApi.getRowNode(blockedSite.id);
                return !existingBlockedSite;              
            });

			if (blockedSites && ui.addedBlockedSites) {
				this.gridApi.updateRowData({
					add: blockedSites
				});
			}
		});

		this.deleteBlockedSitesDisposer = autorun(() => {
			if (ui.deletedBlockedSites.length != 0) {
				const blockedSites = ui.deletedBlockedSites.map(function(blockedSite) {
					return {
						id: blockedSite.id
					};
				});
				this.gridApi.updateRowData({
					remove: blockedSites
				});
			}
		});
	};

	componentWillUnmount() {
        if (this.addBlockedSitesDisposer != null) {
            this.addBlockedSitesDisposer();
        }
		if (this.deleteBlockedSitesDisposer != null) {
			this.deleteBlockedSitesDisposer();
		}
	}

	createColumnDefs() {
		const gridDefs = {
			columnDefs: [
				{
					headerName: "Site",
					field: "id",
					headerCheckboxSelection: true,
					headerCheckboxSelectionFilteredOnly: true,
					checkboxSelection: true,
					suppressMenu: true
				}
			],
			groupDefaultExpanded: -1,
			rowSelection: "multiple"
		};
		return gridDefs;
	}

	addBlockedSites = blockedSites => {
		const {
			rootStore: { optionsStore }
		} = this.props;
		optionsStore.remoteAddBlockedSites(blockedSites);
	};

	showAddBlockedSitesDialog = () => {
		const {
			rootStore: { optionsStore }
		} = this.props;

		optionsStore.showAddBlockedSitesDialog();
	};

	hideAddBlockedSitesDialog = () => {
		const {
			rootStore: { optionsStore }
		} = this.props;

		optionsStore.hideAddBlockedSitesDialog();
	};

	deleteBlockedSites = () => {
		const selectedRows = this.gridApi.getSelectedRows();
		const selectedBlockedSites = selectedRows.map(function(row) {
			return {
				id: row.id
			};
		});

		const {
			rootStore: { optionsStore }
		} = this.props;

		optionsStore.remoteDeleteBlockedSites(selectedBlockedSites);
	};

	render() {
		const gridDefs = this.createColumnDefs();

		const {
			rootStore: { optionsStore }
		} = this.props;
		const ui = optionsStore.ui;

		const blockedSites = optionsStore.blockedSites.slice();

		let addBlockedSitesDialog = (
			<AddBlockedSitesDialog
				ui={optionsStore.ui}
				addBlockedSites={this.addBlockedSites}
				hideDialog={this.hideAddBlockedSitesDialog}
			/>
		);

		let spinning = ui.deletingBlockedSites == true;

		return (
			<Fragment>
				{addBlockedSitesDialog}
				<Spin spinning={spinning}>
					<Form className={styles.rxform}>
						<FormItem>
							<Button type="primary" onClick={this.showAddBlockedSitesDialog}>
								Add
							</Button>
							<Divider type="vertical" />
							<Popconfirm
								title="Do you really want to delete selected blocked sites?"
								onConfirm={this.deleteBlockedSites}
							>
								<Button type="primary">Delete</Button>
							</Popconfirm>
							<Divider type="vertical" />
						</FormItem>
					</Form>
					<div
						style={{
							boxSizing: "border-box",
							height: (window.screen.height * 3) / 4,
							width: "100%"
						}}
						className="ag-theme-balham"
					>
						<AgGridReact
							id="myGrid"
							columnDefs={gridDefs.columnDefs}
							enableColResize={true}
							enableSorting={true}
							groupSelectsChildren={true}
							groupDefaultExpanded={gridDefs.groupDefaultExpanded}
							autoGroupColumnDef={gridDefs.autoGroupColumnDef}
							defaultColDef={gridDefs.defaultColDef}
							rowData={blockedSites}
							enableRangeSelection={true}
							rowSelection={gridDefs.rowSelection}
							suppressRowClickSelection={true}
							onRowSelected={this.onRowSelected}
							onSelectionChanged={this.onSelectionChanged}
							getRowNodeId={data => {                                
								return data.id;
							}}
							onSortChanged={e => {
								// console.log(e.api.getSortModel());
							}}
							deltaRowDataMode={true}
							onGridReady={this.onGridReady}
						/>
					</div>
				</Spin>
			</Fragment>
		);
	}
}

@inject("rootStore")
@observer
class BlockedSitesTab extends Component {
	render() {
		return <BlockedSitesForm />;
	}
}

export default BlockedSitesTab;
